export default {
    methods: {
        stripHtml(string) {
            var temporalDivElement = document.createElement("div");
            temporalDivElement.innerHTML = string;
            return (
                temporalDivElement.textContent || temporalDivElement.innerText || ""
            );
        }
    }
}
